module.exports = __webpack_public_path__ + "img/Weapon_204.4b49b711.png";